/* eslint-disable react/jsx-key */
// Station
import React, { useState, useMemo } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo, getEnvConfig, getPermitActions } from 'core'
import { connect } from 'react-redux'
import {
  getStationInfo,
  postStationInfo,
  deleteStationInfo,
} from 'api/pgads.js'
import CommonScreen from './CommonScreen'
import { Input, Button } from 'antd'
import styled from 'styled-components'
import { STATIONS } from 'core/action-names'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits } from 'core/utils'

const TableTD = styled.td`
  text-align: end;
`
const headers = [
  strCol({
    ident: 'station',
    display: 'Station Code',
    isKey: true,
  }),
  strCol({
    ident: 'stationName',
    display: 'Station Name',
    isFiltered: true,
    isRequired: true,
    width: 300,
  }),
  strCol({
    ident: 'fmsId',
    display: 'FMS ID',
    isFiltered: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getStationInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data => postStationInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteStationInfo(apiTargetInfo)(data)

const title = 'Station'

const Station = props => {
  const [insertEvent, setInsertEvent] = useState(false)
  const { authGodMode } = props.envConfig

  const actionPermits = props.actionPermits
  const showFMSId = useMemo(
    _ =>
      !hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.STATION_HIDE_FMSID],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const onRetrieveData = data => {
    // const d = R.compose(
    //   R.fromPairs,
    //   R.map(a => [a.station, a.stationName])
    // )(data)

    props.saveStationMap(data)
  }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Station Code :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Input
                maxLength={4}
                key="station"
                value={insertData.station}
                placeholder="Station Code"
                name="station"
                onChange={e =>
                  setInsertData({ ...insertData, station: e.target.value })
                }
              />
            </td>
            <TableTD>Station Name :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Input
                key="stationName"
                value={insertData.stationName}
                placeholder="Station Name"
                name="stationName"
                onChange={e =>
                  setInsertData({ ...insertData, stationName: e.target.value })
                }
              />
            </td>
            {showFMSId && [
              <TableTD>FMS ID :</TableTD>,
              <td style={{ minWidth: '150px' }}>
                <Input
                  key="fmsId"
                  value={insertData.fmsId}
                  placeholder="FMS ID"
                  name="fmsId"
                  onChange={e =>
                    setInsertData({ ...insertData, fmsId: e.target.value })
                  }
                />
              </td>,
            ]}
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const newHeadere = useMemo(
    _ => headers.filter(f => (f.ident !== 'fmsId' ? true : showFMSId)),
    [showFMSId]
  )

  return [
    <CommonScreen
      onRetrieveData={onRetrieveData}
      title={title}
      header={newHeadere}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.stationName}
      autoRetrieve
      // sortOptions={[{ ident: 'stationName', display: 'Station Name', sortOrder: 'asc' }]}
      widthOffset={400}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

const mapDispatchToMap = dispatch => ({
  saveStationMap: stations => dispatch({ type: STATIONS, payload: stations }),
  // saveStation
})

export default connect(mapStateToProps, mapDispatchToMap)(Station)
